import React, { useState } from 'react';
import { Button, Card, Row, Modal } from 'react-bootstrap';
import { FaCopy, FaPencilAlt } from 'react-icons/fa';
import format from '~/Utils/format';
import colors from '~/Utils/Styling/colors';
import SolicitacaoDetalhes from './SolicitacaoDetalhes';
import TransmissaoDocs from '~/Pages/TransmissaoDocumentos';
import {
  caracteristicas,
  tipoBooleano,
  TIPOS_SOLICITACAO,
  TipoStatusSolicitacao,
} from '~/constants';
import AuthStorage from '~/Utils/AuthStorage';
import { toast } from 'react-toastify';
import api from '~/Services/api';

function CardSolicitacao({ solicitacao, onCardClick, mostrarDetalhes }) {
  const [solicitacaoState, setSolicitacaoState] = useState(solicitacao);
  const [showDetails, setShowDetails] = useState(false);
  const [showEditModal, setShowEditModal] = useState(false);
  const TemPermissaoGerenciaSolicitacao = AuthStorage.temCaracteristica(
    caracteristicas.GerenciaSolicitacao
  );
  const [carregando, setCarregando] = useState(false);
  const [checkedEmAnalise, setCheckedEmAnalise] = useState(
    solicitacaoState.log_status.status === 4
  );
  const codigoUsuario = AuthStorage.getUser().usuario;

  function toggleDetailsView(e) {
    e.stopPropagation();
    setShowDetails(!showDetails);
  }

  const formatarTexto = texto => {
    if (!texto) return texto;
    return texto
      .normalize('NFD')
      .replace(/[\u0300-\u036f]/g, '')
      .replace(/[^\w\s.,;:!?\-()]/g, '');
  };

  const solicitacaoData = {
    ...solicitacao,
    digitalizacoes: '',
    log_status: '',
    codigo_usuario: '',
    valor: '',
    numero_documento: '',
    data_entrada: '',
    data_vencimento: '',
    informacoes_extra: formatarTexto(solicitacao.informacoes_extra),
    justificativa: formatarTexto(solicitacao.justificativa),
    observacoes: formatarTexto(solicitacao.observacoes),
  };

  const solicitacaoQueryString = btoa(
    encodeURIComponent(JSON.stringify(solicitacaoData))
  );

  const bgClass =
    solicitacaoState.nivel === 0
      ? colors.mutedLight
      : solicitacaoState.selected
      ? colors.successLight
      : 'white';

  const obterStatusSolicitacao = solicitacao => {
    switch (solicitacao.status_solicitacao) {
      case 1:
        return { descricao: 'Solicitado', cor: 'gray' };
      case 2:
        return { descricao: 'Processado', cor: 'green' };
      case 3:
        return { descricao: 'Reprovado', cor: 'red' };
      case 4:
        return { descricao: 'Em análise', cor: 'orange' };
      case 5:
        return { descricao: 'Ajustado', cor: 'blue' };
      default:
        return {};
    }
  };

  const changeStatusSolicitacao = async infos => {
    try {
      setCarregando(true);
      let request = {
        codigo_despesa_projeto_solicitacao: solicitacaoState.codigo_solicitacao,
        codigo: infos.log_status.codigo,
        codigo_suario: 0,
        nome_usuario: '',
        data_registro: null,
        status: !checkedEmAnalise
          ? TipoStatusSolicitacao.EmAnalise
          : TipoStatusSolicitacao.Solicitado,
      };

      setCheckedEmAnalise(!checkedEmAnalise);

      let response = await api.changeStatusSolicitacao(request);
      if (response) {
        setSolicitacaoState(prevState => ({
          ...prevState,
          log_status: response,
          status_solicitacao: response.status,
        }));
      }
    } catch (error) {
      toast.error(error.message);
    } finally {
      setCarregando(false);
    }
  };

  return (
    <Card
      style={{ background: bgClass, borderStyle: 'solid' }}
      className="my-2 cursor-pointer border border-2 border-dark"
    >
      <div className="row pt-3 px-3">
        <div className="col-12 d-flex align-items-center justify-content-between">
          <div>
            {TemPermissaoGerenciaSolicitacao &&
              solicitacaoState.status_solicitacao !==
                TipoStatusSolicitacao.Processado &&
              solicitacaoState.status_solicitacao !==
                TipoStatusSolicitacao.Reprovado && (
                <div className="form-check">
                  <input
                    className="form-check-input"
                    type="checkbox"
                    key={solicitacaoState.log_status}
                    checked={checkedEmAnalise}
                    onChange={() => {
                      changeStatusSolicitacao(solicitacaoState);
                    }}
                    disabled={carregando}
                  />
                  {solicitacaoState.status_solicitacao !==
                  TipoStatusSolicitacao.EmAnalise ? (
                    <strong className="px-1">Analisar solicitação</strong>
                  ) : (
                    <>
                      <strong className="px-1" style={{ color: 'green' }}>
                        Solicitação em análise -{' '}
                        {solicitacaoState.log_status.nome_usuario}
                      </strong>
                    </>
                  )}
                </div>
              )}
          </div>

          <div>
            <strong
              style={{
                color:
                  obterStatusSolicitacao(solicitacaoState).cor === 'gray'
                    ? ''
                    : obterStatusSolicitacao(solicitacaoState).cor,
              }}
              className="mr-1"
            >
              {obterStatusSolicitacao(solicitacaoState).descricao}
            </strong>
          </div>
        </div>
      </div>

      <Card.Title className="d-flex justify-content-between pt-1 px-3 pb-0 mb-0">
        <div>
          #{solicitacaoState.codigo_solicitacao}
          {' - '}
          {(() => {
            switch (solicitacaoState.codigo_despesa_projeto_tipo_solicitacao) {
              case TIPOS_SOLICITACAO.Despesa:
                return 'Despesa';
              case TIPOS_SOLICITACAO.Projeto:
                return 'Projeto';
              case TIPOS_SOLICITACAO.Comissao:
                return 'Comissão';
              default:
                return '';
            }
          })()}
        </div>
        <div>
          <small>
            {solicitacaoState.nome_usuario_completo}
            {' - '}
            {format.datetime(solicitacaoState.data_solicitacao)}
          </small>
        </div>
      </Card.Title>

      <Card.Body onClick={onCardClick} name="card-chave">
        <div className="row">
          <div className="col-12">
            <Row className="w-100 justify-content-end">
              <div className="">
                <a
                  href={`/transmissao-documentos?solicitacao=${solicitacaoQueryString}`}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="badge badge-secondary p-2"
                  style={{
                    textDecoration: 'none',
                    fontSize: '0.875rem',
                    cursor: 'pointer',
                  }}
                >
                  <FaCopy className="mr-1" />
                  Duplicar solicitação
                </a>
              </div>
            </Row>
            <Row>
              <small className="text-muted col-12 col-md-3  text-md-right p-md-0">
                GE
              </small>
              <div className="col-md-9 col-12">
                <span className="mr-1">{solicitacaoState.ge}:</span>
                <span>{solicitacaoState.nome_ge}</span>
              </div>
            </Row>
            {solicitacaoState.descricao_conta_interna && (
              <Row>
                <small className="text-muted col-12 col-md-3  text-md-right p-md-0">
                  Conta interna
                </small>
                <div className="col-md-9 col-12">
                  <span className="mr-1">
                    {solicitacaoState.codigo_conta_interna}:
                  </span>
                  <span>{solicitacaoState.descricao_conta_interna}</span>
                </div>
              </Row>
            )}
            {solicitacaoState.descricao_despesa_receita && (
              <Row>
                <small className="text-muted col-12 col-md-3  text-md-right p-md-0">
                  Conta
                </small>
                <div className="col-md-9 col-12">
                  <span className="mr-1">
                    {solicitacaoState.codigo_despesa_receita}:
                  </span>
                  <span>{solicitacaoState.descricao_despesa_receita}</span>
                </div>
              </Row>
            )}
            {solicitacaoState.solicitacao_projeto === 1 &&
              solicitacaoState.descricao_centro_de_custo && (
                <Row>
                  <small className="text-muted col-12 col-md-3  text-md-right p-md-0">
                    Centro de custo
                  </small>
                  <div className="col-md-9 col-12">
                    <span className="mr-1">
                      {solicitacaoState.codigo_centro_de_custo}:
                    </span>
                    <span>{solicitacaoState.descricao_centro_de_custo}</span>
                  </div>
                </Row>
              )}
            <Row>
              <small className="text-muted col-12 col-md-3  text-md-right p-md-0">
                Departamento
              </small>
              <div className="col-md-9 col-12">
                <span className="mr-1">
                  {solicitacaoState.codigo_departamento}:
                </span>
                <span>{solicitacaoState.nome_departamento}</span>
              </div>
            </Row>
            {solicitacaoState.nome_fornecedor && (
              <Row>
                <small className="text-muted col-12 col-md-3  text-md-right p-md-0">
                  Fornecedor
                </small>
                <div className="col-md-9 col-12">
                  <span className="mr-1">
                    {solicitacaoState.codigo_fornecedor}:
                  </span>
                  <span>{solicitacaoState.nome_fornecedor}</span>
                </div>
              </Row>
            )}
            <Row>
              <small className="text-muted col-12 col-md-3  text-md-right p-md-0">
                Data de entrada
              </small>
              <div className="col-md-9 col-12">
                <span className="mr-1">
                  {format.date(solicitacaoState.data_entrada)}
                </span>
              </div>
            </Row>
            <Row>
              <small className="text-muted col-12 col-md-3  text-md-right p-md-0">
                Data de vencimento:
              </small>
              <div className="col-md-9 col-12">
                <span className="mr-1 text-danger">
                  {format.date(solicitacaoState.data_vencimento)}
                </span>
              </div>
            </Row>
            <Row>
              <small className="text-muted col-12 col-md-3  text-md-right p-md-0">
                Tipo documento:
              </small>
              <div className="col-md-9 col-12">
                <span className="mr-1">{solicitacaoState.tipo_documento}</span>
              </div>
            </Row>
            <Row>
              <small className="text-muted col-12 col-md-3  text-md-right p-md-0">
                Tipo de pagamento:
              </small>
              <div className="col-md-9 col-12">
                <span className="mr-1">{solicitacaoState.tipo_pagamento}</span>
              </div>
            </Row>
            <Row>
              <small className="text-muted col-12 col-md-3  text-md-right p-md-0">
                Tem rateio:
              </small>
              <div className="col-md-9 col-12">
                <span className="mr-1">
                  {solicitacaoState.tem_rateio === tipoBooleano.Sim
                    ? 'Sim'
                    : 'Não'}
                </span>
              </div>
            </Row>
            <Row>
              <small className="text-muted col-12 col-md-3  text-md-right p-md-0">
                Valor
              </small>
              <div className="col-md-9 col-12">
                <span className="mr-1">
                  {format.money(solicitacaoState.valor)}
                </span>
              </div>
            </Row>
            {solicitacaoState.numero_documento && (
              <>
                <Row>
                  <small className="text-muted col-12 col-md-3  text-md-right p-md-0">
                    Número da nota
                  </small>

                  <div className="col-md-9 col-12">
                    <span className="mr-1">
                      {solicitacaoState.numero_documento}
                    </span>
                  </div>
                </Row>
              </>
            )}
            {solicitacaoState.data_emissao_nf && (
              <Row>
                <small className="text-muted col-12 col-md-3  text-md-right p-md-0">
                  Data emissão NF:
                </small>
                <div className="col-md-9 col-12">
                  <span className="mr-1">
                    {format.date(solicitacaoState.data_emissao_nf)}
                  </span>
                </div>
              </Row>
            )}
            {solicitacaoState.observacoes && (
              <Row>
                <small className="text-muted col-12 col-md-3  text-md-right p-md-0">
                  Observações
                </small>
                <div className="col-md-9 col-12">
                  <span className="mr-1">{solicitacaoState.observacoes}</span>
                </div>
              </Row>
            )}
            {solicitacaoState.informacoes_extra && (
              <Row>
                <small className="text-muted col-12 col-md-3  text-md-right p-md-0">
                  Informações extras
                </small>
                <div className="col-9 ">
                  <span className="mr-1">
                    {solicitacaoState.informacoes_extra}
                  </span>
                </div>
              </Row>
            )}
            {solicitacaoState.status_solicitacao &&
              solicitacaoState.status_solicitacao ===
                TipoStatusSolicitacao.Reprovado &&
              solicitacaoState.justificativa && (
                <Row>
                  <small className="text-muted col-12 col-md-3  text-md-right p-md-0">
                    Justificativa
                  </small>
                  <div className="col-md-9 col-12">
                    <span className="mr-1">
                      {solicitacaoState.justificativa}
                    </span>
                  </div>
                </Row>
              )}
          </div>
        </div>
        <div className="d-flex justify-content-end">
          <div>
            <Button
              variant="link"
              className="float-right"
              onClick={toggleDetailsView}
            >
              Detalhes
            </Button>
            {solicitacaoState.status_solicitacao ===
              TipoStatusSolicitacao.Reprovado &&
              solicitacaoState.codigo_usuario === codigoUsuario && (
                <Button
                  variant="link"
                  className="float-right"
                  onClick={e => {
                    e.stopPropagation();
                    setShowEditModal(true);
                  }}
                >
                  <FaPencilAlt />
                  <strong className="px-1">Editar</strong>
                </Button>
              )}
          </div>
        </div>
        {showDetails && (
          <SolicitacaoDetalhes
            solicitacao={solicitacaoState}
            mostrarDetalhes={mostrarDetalhes}
          />
        )}
      </Card.Body>

      <Modal
        show={showEditModal}
        onHide={() => setShowEditModal(false)}
        size="xl"
        backdrop="static"
      >
        <Modal.Header closeButton>
          <Modal.Title>Editar Solicitação</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <TransmissaoDocs solicitacao={solicitacaoState} />
        </Modal.Body>
      </Modal>
    </Card>
  );
}

export default React.memo(CardSolicitacao);
